/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} User_Last_ModifiedInputs */



/**
* | output |
* | --- |
* | "Last modified: {date}" |
*
* @param {User_Last_ModifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_last_modified = /** @type {((inputs: User_Last_ModifiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Last_ModifiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dernière modification : ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Última modificación: ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Última modificação: ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ultima modifica: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Last modified: ${i?.date}`)
});